package com.partejar.app.feature.home.data

import kotlin.js.Date

internal actual fun currentHomeDateTime(): HomeDateTime {
    val date = Date()
    val jsDay = date.getDay()
    return HomeDateTime(
        hour = date.getHours(),
        dayOfWeek = if (jsDay == 0) 7 else jsDay,
        dayOfMonth = date.getDate(),
        month = date.getMonth() + 1,
        year = date.getFullYear()
    )
}
